export default __webpack_public_path__ + "24cf0cc86f97d76df8886189215c28df.png";